import axios from "axios";

const state = {
  roles: []
};

const actions = {
  getAssignableRoles: ({ commit }) => {
    return axios.get(`/roles`)
      .then((resp) => {
        commit("roleIndexSuccess", resp.data.roles);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }
};

const mutations = {
  roleIndexSuccess: (state, roles) => {
    state.roles = roles;
  }
};

export default {
  state,
  actions,
  mutations
};
